import React, { Component } from 'react';
import { Container } from '@bit/ui-common.ui-components/ss-components';
import { Row, Col } from 'antd';
import { VIEWS } from '../../../utils/yourAccountUtils';
import YourAccountLoadingIndicator from './YourAccountLoadingIndicator';
import * as YourAccountServices from '../../../redux/services/yourAccountServices';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

class DataEntry extends Component {
    constructor(props) { super(props); }

    formatInput(f, v) {
        switch(f) {
            case 'Role': return v === 'PROVIDER_ADMIN' ? 'Provider Admin' : v;
            default: return v;
        }
    }

    render() {
        const { field, value, style } = this.props;
        return (
            <Row type='flex' justify='space-around' align='middle' gutter={8} style={style}>
                <Col span={12}>
                    <span style={{ fontWeight: 'bold' }}>
                        {`${field}:`}
                    </span>
                </Col>
                <Col span={12} style={{ textAlign: 'left' }}>
                    {this.formatInput(field, value)}
                </Col>
            </Row>
        );
    }
}

class AccountInfo extends Component {
    constructor(props) { super(); }

    highlighter(entries) {
        let
        keyPrefix = 'your-account-account-info-data-entry-',
        commonStyle = {
            lineHeight: '30px',
            borderRadius: '4px',
            overflow: 'auto'
        },
        props = i => ({
            key: `${keyPrefix}${i}`,
            style: commonStyle
        });
        return entries.map((e, i) => i%2 === 0
            ? React.cloneElement(e, {...props(i), style: {...commonStyle, background: 'rgb(240, 240, 240)' } })
            : React.cloneElement(e, {...props(i)})
        );
    }

    render() {
        const
        p = this.props,
        { loading, services, commonData } = p,
        {geoData} = commonData;
        return (
            <div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={p.fullWidth ? 24 : 12}>
                        {this.highlighter([
                            <DataEntry field='User ID' value={p.userName}/>,
                            <DataEntry field='Attaché Name' value={
                                `${p.firstName != null && p.firstName.length > 0 ? p.firstName : ''}` +
                                `${p.lastName != null && p.lastName.length > 0 ? ` ${p.lastName}` : '-'}`
                            } />,
                            <DataEntry field='DOD Attaché Office Address' value={
                                `${p.dodAttache.streetAddress},\n` +
                                `${p.dodAttache.city},\n` +
                                ssCommonUtils.stateCodeLookupcounterData( geoData.geoDataStore, p.dodAttache.country,  p.dodAttache.stateProvince) + ',\n ' +
                                ssCommonUtils.countryCodeLookupcounterData( geoData.geoDataStore, p.dodAttache.country )
                            } />,
                            <DataEntry field='U.S. Diplomatic Consulate or Embassy' value={ssCommonUtils.countryCodeLookupcounterData( geoData.geoDataStore, p.dodAttache.embassy )}/>,
                            <DataEntry field='Phone (when calling from the U.S.)' value={p.dodAttache.phoneNumber} />,
                            <DataEntry field='Email (must be .mil or state.gov )' value={p.emailAddress} />
                        ])}
                    </Col>
                </Row>
                <Row>
                  <Col span={23}>
                   <div style={{fontWeight:'bold'}}>
                  {'Please make sure that the information listed above is correct. It will be included in any Endorsements that you create.'}
                  </div><br/>
                  <div>
                    {'If you need to correct your name, address, or Embassy assignment, please contact FTSP at FTSP.Help@tsa.dhs.gov or (571) 227-1004'}
                  </div>

                                </Col>

                </Row>
            </div>
        );
    }
}

export default Container({
    state: state => state.yourAccount,
    services: [ YourAccountServices ]
},
class DodAccount extends Component {
    constructor(props) { super(props); }

    getYourAccountData() {
        const
        { getYourAccountData } = this.props.services,
        { jti } = window.session;
        getYourAccountData(`/user/${jti}`);
    }

    injectProps() {
        const { displayRole, fullWidth } = this.props;
        return [
            <AccountInfo key={'your-account-account-info'} />
        ].map(e => React.cloneElement(e, {...this.props, displayRole, fullWidth }));
    }

    componentDidMount() {
        this.getYourAccountData();
    }

    componentDidUpdate(prev) {
        const
        { services } = this.props,
        prevRequests = prev.requests,
        currRequests = this.props.requests;

        switch(currRequests.data.status) {
            case 'success':
            case 'failure':
                if(prevRequests.data.status === 'pending') {
                    this.getYourAccountData();
                    services.resetDataRequest();
                    services.toggleShowView(true);
                }
                break;
        }

        switch(currRequests.updateContactInfo.status) {
            case 'success':
            case 'failure':
                if(prevRequests.updateContactInfo.status === 'pending') {
                    services.resetContactInfoRequest();
                    this.getYourAccountData();
                }
                break;
        }
    }

    render() {
        const
        { view, showView, fullWidth } = this.props,
        { data } = this.props.requests,
        views = this.injectProps();

        if(showView)
            if(view == VIEWS.YOUR_ACCOUNT)
                return views[0];

        return <YourAccountLoadingIndicator />;
    }
});
